export const API_URL = process.env.REACT_APP_ENV === 'local' ? 'http://localhost:8080/api' :
process.env.REACT_APP_ENV === 'prod' ? 'https://node.1-2-lern.de/api' :
 'https://node-dev.1-2-lern.de/api';
